import * as React from "react";
import { cn } from "@/lib/utils";

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
  ({ children, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "tw-container tw-mx-auto tw-px-4 tw-py-6 sm:tw-px-6 lg:tw-px-8",
          className
        )}
      >
        {children}
      </div>
    );
  }
);

PageContainer.displayName = "PageContainer";

export { PageContainer };
